export const applicationRateCountKey = "applicationRateCount";
